import React, { useEffect, useState } from "react";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import "./raiseInvoicePdfView.scss";
import PDFViewForReceipt from "./PDFViewForReceipt";
import axios from "axios";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import { APPLICABLE_ROLE } from "../DashboardAppointmentsView/Constant";
import ClinicShareReceiptModal from "../ClinicComponents/ClinicMyAppointments/ClinicShareReceiptModal";
import Loader from "../UI Component/Loader/Loader";
import ReceiptPreviewContainerHeaderView from "./ReceiptPreviewContainerHeaderView";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import {
  convertToBooleanHelper,
  getReceiptFooterData,
  getReceiptHeaderData,
} from "./helper";

const RaiseInvoicePDFView = ({
  pdfReceiptData,
  handleClosePdfPreview,
  user_id,
  clinic_id,
  staff_id,
  user_type,
  appointment,
}) => {
  const [pdfBlobUrl, setPdfBlobUrl] = useState("");
  const [pdfBlob, setPdfBlob] = useState("");
  const [showHeaderLoader, setShowHeaderLoader] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const [showReceiptModal, setshowReceiptModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [finalReceiptData, setFinalReceiptData] = useState({
    receiptData: {},
    loadedAllData: false,
  });
  const [docs, setDocs] = useState("");
  const [blobList, setBlobList] = useState([]);
  const [tempBlob, setTempBlob] = useState("");

  useEffect(() => {
    if (tempBlob && finalReceiptData?.loadedAllData) {
      //getting multiple blob
      let list = [...blobList];
      list.push(tempBlob);
      setBlobList(list);
    }
  }, [tempBlob, finalReceiptData]);

  useEffect(() => {
    if (blobList?.length > 1) {
      //filtering blob based on the size (copleted data is rendered)
      const final_blob = blobList.reduce((max, curren) =>
        max.size > curren.size ? max : curren
      );
      setPdfBlob(final_blob);
    }
  }, [blobList]);

  useEffect(() => {
    if (pdfBlob) {
      let reader = new FileReader();
      reader.readAsDataURL(tempBlob);
      reader.onloadend = () => {
        let base64data = reader.result;
        setDocs([
          {
            uri: `${base64data}`,
          },
        ]);
      };
      handleGenerateInvoice();
    }
  }, [pdfBlob]);

  useEffect(() => {
    if (pdfReceiptData?.payload_reciept) {
      let data = pdfReceiptData;
      data.payload_reciept = convertToBooleanHelper(data?.payload_reciept);

      data = getReceiptHeaderData(data);
      data = getReceiptFooterData(data);
      setFinalReceiptData({ receiptData: { ...data }, loadedAllData: true });
    }
  }, [pdfReceiptData]);

  const handleGenerateInvoice = async () => {
    setShowHeaderLoader(true);
    setShowShare(false);
    const arrayBuffer = await pdfBlob.arrayBuffer();
    const buffer = Buffer.from(arrayBuffer);
    let bufferbase64 = new Buffer.from(buffer, "base64");
    const file = dataURLtoFile(
      "data:pdf;base64," + bufferbase64?.toString("base64")
    );
    const data = new FormData();
    Object.keys(pdfReceiptData?.invoice_path?.fields).forEach((keyName) => {
      data.append(keyName, pdfReceiptData?.invoice_path?.fields[keyName]);
    });
    data.append("file", file, "receipt_pdf");
    axios
      .post(pdfReceiptData?.invoice_path?.url, data, {
        headers: {
          "Content-Type":
            "multipart/form-data;boundary=--WebKitFormBoundaryE19zNvXGzXaLvS5C",
        },
      })
      .then((response) => {
        console.log(response);
        setShowHeaderLoader(false);
        setShowShare(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n) {
      u8arr[n - 1] = bstr.charCodeAt(n - 1);
      n -= 1; // to make eslint happy
    }
    return new File([u8arr], filename, { type: mime });
  };

  const printPDF = () => {
    if (window?.innerWidth < 768) {
      window.open(pdfBlobUrl, "PRINT", "height=400,width=600");
    } else {
      const iframe = document.createElement("iframe"); //load content in an iframe to print later
      document.body.appendChild(iframe);

      iframe.style.display = "none";
      iframe.src = pdfBlobUrl;
      iframe.onload = function () {
        setTimeout(function () {
          iframe.focus();
          iframe.contentWindow.print();
        }, 1);
      };
    }
  };

  const downloadFile = () => {
    let link = document.createElement("a");
    link.href = pdfBlobUrl;
    link.download = "Invoice for Your Connect2Clinic appointment";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const shareReceipt = (appnt) => {
    setLoading(true);
    let payload = {
      doctor_id: user_type === "staff" ? appnt.doctor_id : user_id,
      user_type: user_type,
      appointment_id: appnt.appointment_id,
      ...(appnt?.order_id && { order_id: appnt?.order_id }),
    };
    if (user_type === APPLICABLE_ROLE.STAFF) {
      payload = {
        ...payload,
        staff_id: staff_id,
      };
    }
    afterLoginApiAxios
      .post("api/v1/doctor/share-receipt", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setshowReceiptModal(true);
          setTimeout(function () {
            setshowReceiptModal(false);
            handleClosePdfPreview();
          }, 2000);
        }
        setLoading(false);
      })
      .catch((err) => C2CConsole.log(err));
  };

  return (
    <div className="raise-invoice-pdf-view-container">
      {loading && <Loader />}
      {finalReceiptData?.loadedAllData && (
        <>
          <>
            <ReceiptPreviewContainerHeaderView
              showShare={showShare}
              showLoader={showHeaderLoader}
              handleShare={() => {
                shareReceipt(appointment);
              }}
              handlePrint={() => {
                printPDF();
              }}
              handleDownload={() => {
                downloadFile();
              }}
              handleCloseRecipt={handleClosePdfPreview}
            />
            {window?.innerWidth > 768 ? (
              <PDFViewer
                style={{ width: "100%", height: "calc(100vh - 72px)" }}
                showToolbar={false}
              >
                <PDFViewForReceipt receiptData={pdfReceiptData} />
              </PDFViewer>
            ) : (
              docs?.length > 0 && (
                <DocViewer
                  documents={docs}
                  pluginRenderers={DocViewerRenderers}
                  style={{
                    width: "100%",
                    //  height: 800,
                  }}
                  config={{
                    header: {
                      disableHeader: false,
                      disableFileName: false,
                      retainURLParams: false,
                    },
                  }}
                />
              )
            )}
          </>

          <ClinicShareReceiptModal show={showReceiptModal} />
          <PDFDownloadLink
            document={<PDFViewForReceipt receiptData={pdfReceiptData} />}
            fileName={`Invoice for Your Connect2Clinic appointment`}
          >
            {({ loading, url, blob }) =>
              loading ? (
                <></>
              ) : (
                <>
                  {setPdfBlobUrl(url)}
                  {setTempBlob(blob)}
                </>
              )
            }
          </PDFDownloadLink>
        </>
      )}
    </div>
  );
};

export default RaiseInvoicePDFView;
